export const SHOE_CONDITIONS = {
  NEW: 'new',
  NEW_NO_DEFECTS: 'new_no_defects',
  NEW_WITH_DEFECTS: 'new_with_defects',
  USED: 'used',
  GOAT_CLEAN: 'goat_clean',
};

export const BOX_CONDITIONS = {
  GOOD_CONDITION: 'good_condition',
  MISSING_LID: 'missing_lid',
  BADLY_DAMAGED: 'badly_damaged',
  NO_ORIGINAL_BOX: 'no_original_box',
};
